/* eslint-disable max-len */
/* eslint-disable unicorn/prefer-module, no-console */
import React, { useEffect, useRef, useState, useCallback, useMemo } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { useAuthContext } from "../../context/auth";
import audienciaIcon from "../../img/landing/chile/iconos/audiencia.svg";
// import consultoriaIcon from "../../img/landing/chile/iconos/consultoria.svg";
import eficienciaIcon from "../../img/landing/chile/iconos/eficiencia.svg";
import flexibilidadIcon from "../../img/landing/chile/iconos/flexibilidad.svg";
// import implementacionIcon from "../../img/landing/chile/iconos/implementacion.svg";
// import logoInstagram from "../../img/landing/chile/iconos/insta.svg";
// import logoLinkedin from "../../img/landing/chile/iconos/linkedin.svg";
// import mantenimientoIcon from "../../img/landing/chile/iconos/mantenimiento.svg";
import banderaPeru from "../../img/landing/chile/iconos/peru.svg";
import respaldoIcon from "../../img/landing/chile/iconos/respaldocuantiativo.svg";
import banderaUruguay from "../../img/landing/chile/iconos/uruguay.svg";
// import logoYoutube from "../../img/landing/chile/iconos/youtube.svg";
import landingFondo01 from "../../img/landing/chile/landingfondo01.jpg";
import landingFondo02 from "../../img/landing/chile/landingfondo02.jpg";
import landingFondo03 from "../../img/landing/chile/landingfondo03.jpg";
import landingFondo04 from "../../img/landing/chile/landingfondo04.jpg";
import landingFondo05 from "../../img/landing/chile/landingfondo05.jpg";
import landingFondo06 from "../../img/landing/chile/landingfondo06.jpg";
import landingFondo07 from "../../img/landing/chile/landingfondo07.jpg";
import landingFondo08 from "../../img/landing/chile/landingfondo08.jpg";
import landingFondo09 from "../../img/landing/chile/landingfondo09.jpg";
import landingFondo10 from "../../img/landing/chile/landingfondo10.jpg";
import landingFondo11 from "../../img/landing/chile/landingfondo11.jpg";
import landingFondo12 from "../../img/landing/chile/landingfondo12.png";
import { Mapa2 } from "../../pages/Mapa2";
import { getEdificiosOperativos } from "../../utils";
import { getLocale } from "../../utils/getLocale";
import logo01 from "./logos/aramco.png";
import logo02 from "./logos/bmw.svg";
import logo03 from "./logos/burgerking.svg";
import logo04 from "./logos/changan.svg";
import logo05 from "./logos/entel.svg";
import logo06 from "./logos/geely.svg";
import logo07 from "./logos/generalmotoros.svg";
import logo08 from "./logos/hym.svg";
import logo09 from "./logos/interexpo.png";
import logo10 from "./logos/jetsmart.svg";
import logo20 from "./logos/latam.png";
import logo21 from "./logos/lider.png";
import logo24 from "./logos/loreal.svg";
import logo11 from "./logos/mcdonalds.svg";
import logo18 from "./logos/mercadolibre.webp";
import logo12 from "./logos/mitsubishi.svg";
import logo23 from "./logos/nissan.svg";
import logo13 from "./logos/planvital.png";
import logo14 from "./logos/prudential.svg";
import logo25 from "./logos/salesforce.png";
import logo15 from "./logos/samsung.svg";
import logo16 from "./logos/scotiabank.svg";
import logo17 from "./logos/ucchristus.svg";
import logo19 from "./logos/volkswagen.svg";
import logo22 from "./logos/wom.svg";
import logo26 from "./logos/xiaomi.svg";
import logo27 from "./logos/xtb.svg";
import "./LandingPageChile.scss";

const LandingChile = ({ pais = "Chile" }) => {
  // Estado y referencias
  const [edificios, setEdificios] = useState([]);
  const [imageSrc, setImageSrc] = useState({});
  const [currentIndex, setCurrentIndex] = useState(0);
  const [formData, setFormData] = useState({ nombre: "", email: "", telefono: "", mensaje: "" });
  const [submitStatus, setSubmitStatus] = useState(null);
  const heroRef = useRef(null);
  const { pais: authPais } = useAuthContext();
  const resolvedPais = authPais || pais;
  const [prevIndex, setPrevIndex] = useState(null);
  const [ismobile, setIsMobile] = useState(window.innerWidth <= 768);

  const logos = useMemo(() => {
    const logoArray = [
      { src: logo01, id: "aramco" },
      { src: logo02, id: "bmw" },
      { src: logo03, id: "burgerking" },
      { src: logo04, id: "changan" },
      { src: logo05, id: "entel" },
      { src: logo06, id: "geely" },
      { src: logo07, id: "generalmotors" },
      { src: logo08, id: "hym" },
      { src: logo09, id: "interexpo" },
      { src: logo10, id: "jetsmart" },
      { src: logo11, id: "mcdonalds" },
      { src: logo12, id: "mitsubishi" },
      { src: logo13, id: "planvital" },
      { src: logo14, id: "prudential" },
      { src: logo15, id: "samsung" },
      { src: logo16, id: "scotiabank" },
      { src: logo17, id: "ucchristus" },
      { src: logo18, id: "mercadolibre" },
      { src: logo19, id: "volkswagen" },
      { src: logo20, id: "latam" },
      { src: logo21, id: "lider" },
      { src: logo22, id: "wom" },
      { src: logo23, id: "nissan" },
      { src: logo24, id: "loreal" },
      { src: logo25, id: "salesforce" },
      { src: logo26, id: "xiaomi" },
      { src: logo27, id: "xtb" },
    ];

    // Initial Fisher-Yates shuffle
    for (let i = logoArray.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [logoArray[i], logoArray[j]] = [logoArray[j], logoArray[i]];
    }

    // Post-process to ensure jetsmart and latam are not adjacent
    let adjusted = false;
    do {
      adjusted = false;
      for (let i = 0; i < logoArray.length - 1; i++) {
        if (
          (logoArray[i].id === "jetsmart" && logoArray[i + 1].id === "latam") ||
          (logoArray[i].id === "latam" && logoArray[i + 1].id === "jetsmart")
        ) {
          // Swap with a random non-adjacent element
          let swapIndex;
          do {
            swapIndex = Math.floor(Math.random() * logoArray.length);
          } while (swapIndex === i || swapIndex === i + 1);
          [logoArray[i], logoArray[swapIndex]] = [logoArray[swapIndex], logoArray[i]];
          adjusted = true;
        }
      }
    } while (adjusted);

    return logoArray;
  }, []);

  // Navegación
  const handleNavClick = useCallback((sectionId) => {
    document.getElementById(sectionId)?.scrollIntoView({ behavior: "smooth" });
  }, []);

  useEffect(() => {
    const initialize = async () => {
      const newEdificios = await getEdificiosOperativos({ pais: resolvedPais });
      const topEdificios = newEdificios.sort((a, b) => b.personas - a.personas).slice(0, 25);
      setEdificios(topEdificios);
    };
    initialize();
  }, [resolvedPais]);

  useEffect(() => {
    if (edificios) {
      edificios.forEach(async (edificio) => {
        try {
          // Try to import .png first
          const src = await import(`../../img/edificios/${edificio.id}.png`);
          setImageSrc((prevState) => ({ ...prevState, [edificio.id]: src.default }));
        } catch {
          try {
            // Fallback to .jpg if .png fails
            const src = await import(`../../img/edificios/${edificio.id}.jpeg`);
            setImageSrc((prevState) => ({ ...prevState, [edificio.id]: src.default }));
          } catch {
            // If both fail, set to null
            setImageSrc((prevState) => ({ ...prevState, [edificio.id]: null }));
          }
        }
      });
    }
  }, [edificios]);

  const images = useMemo(
    () => [
      landingFondo01,
      landingFondo02,
      landingFondo03,
      landingFondo04,
      landingFondo05,
      landingFondo06,
      landingFondo07,
      landingFondo08,
      landingFondo09,
      landingFondo10,
      landingFondo11,
      landingFondo12,
    ],
    []
  );

  useEffect(() => {
    // Pre-cargar imágenes
    images.forEach((src) => {
      const img = new Image();
      img.src = src;
    });

    const interval = setInterval(() => {
      setPrevIndex(currentIndex);
      const newIndex = (currentIndex + 1) % images.length;
      setCurrentIndex(newIndex);
      setTimeout(() => setPrevIndex(null), 550);
    }, 5000);

    return () => clearInterval(interval);
  }, [currentIndex, images]);

  // Agregar useEffect para manejar resize
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Efecto parallax
  useEffect(() => {
    const handleScroll = () => {
      if (!heroRef.current) return;
      const scrollY = window.scrollY;
      const opacity = Math.max(1 - scrollY / 700, 0.2);
      const transform = `translateY(${scrollY * 0.4}px)`;
      heroRef.current.style.opacity = opacity.toString();
      heroRef.current.style.transform = transform;
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Manejo del carrusel
  const handlePrev = () => setCurrentIndex((prev) => (prev === 0 ? 0 : prev - 1));
  const handleNext = () => setCurrentIndex((prev) => (prev === edificios.length - 1 ? 0 : prev + 1));

  // Manejo del formulario
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitStatus("loading");
    try {
      const response = await fetch("https://wecast.cl/api-mail/contact.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
      const data = await response.json();
      if (response.ok && data.success) {
        setSubmitStatus("success");
        setFormData({ nombre: "", email: "", telefono: "", mensaje: "" });
      } else {
        throw new Error(data.error || "Error al enviar el formulario");
      }
    } catch (error) {
      setSubmitStatus("error");
      console.error("Error submitting form:", error);
    }
  };

  // Subcomponente NavLink
  const NavLink = ({ sectionId, children }) => {
    const [isFocused, setIsFocused] = useState(false);
    return (
      <button
        onClick={() => handleNavClick(sectionId)}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        className="navbar-link-chile"
        aria-current={isFocused ? "page" : undefined}
      >
        {children}
      </button>
    );
  };

  return (
    <>
      {/* NavBar */}
      <nav className="navbar-chile">
        <div className="navbar-container-chile">
          <span className="navbar-logo-text-chile" aria-label="Wecast">
            wecast
          </span>
          <div className="navbar-nav-chile">
            <NavLink sectionId="servicios">Servicios</NavLink>
            <NavLink sectionId="cobertura">Cobertura</NavLink>
            <NavLink sectionId="clientes">Clientes</NavLink>
            {/* <NavLink sectionId="transformacion">Transformación Digital</NavLink> */}
            <button className="navbar-contact-btn-chile" onClick={() => handleNavClick("contacto")}>
              Contacto
            </button>
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <main className="main">
        <section className="hero-section-chile">
          <div className="hero-background-chile" ref={heroRef}>
            {prevIndex !== null && (
              <div
                className="background-slide-chile prev-chile"
                style={{
                  backgroundImage: `url(${images[prevIndex]})`,
                  backgroundSize: "cover",
                }}
              />
            )}
            <div
              className="background-slide-chile current-chile"
              style={{
                backgroundImage: `url(${images[currentIndex]})`,
                backgroundSize: "cover",
              }}
              key={currentIndex}
            />
          </div>
          <div className="hero-overlay-chile" />
          <div className="hero-content-chile">
            <h1>
              <span>Publicidad Digital</span> <br /> en Torres Ejecutivas
            </h1>
            <div className="hero-content-bajada-chile">
              Conecte su marca con una audiencia de valor de manera eficiente, en los espacios más exclusivos de la
              ciudad, a través de circuitos digitales dentro de edificios corporativos.
            </div>
          </div>
        </section>
        <section id="servicios" className="ventajas-section-chile">
          <div className="ventajas-title-chile">Ventajas y Beneficios</div>
          <div className="ventajas-subtitle-chile">Acceda a una plataforma innovadora con ventajas únicas</div>
          <div className="ventajas-grid-chile">
            {[
              {
                icon: audienciaIcon,
                title: "AUDIENCIA PREMIUM",
                text: "Conocimiento preciso del perfil de la audiencia (B2C) y de las empresas en cada edificio (B2B), alcance decenas de miles de ejecutivos, profesionales y tomadores de decisión de empresas destacadas.",
              },
              {
                icon: respaldoIcon,
                title: "RESPALDO CUANTITATIVO",
                text: "Cantidad de individuos respaldada por los propios edificios gracias a sus sistemas de acceso, data fiable y precisa con detalle de visitas y frecuencia de accesos.",
              },
              {
                icon: flexibilidadIcon,
                title: "FLEXIBILIDAD DE PAUTA",
                text: "Tradicional o programática, por día en un único edificio o todo el año en toda la red, alta o baja frecuencia de apariciones según requiera su estrategia.",
              },
              {
                icon: eficienciaIcon,
                title: "EFICIENCIA EN EL IMPACTO",
                text: "Soportes en ambientes de espera obligada con contenidos de valor que garantizan una atención completa del público con alta frecuencia de repetición.",
              },
            ].map((card, index) => (
              <div key={index} className="ventajas-card-chile">
                <img src={card.icon} alt={card.title} className="icon-chile" />
                <div className="ventajas-card-title-chile">{card.title}</div>
                <div className="ventajas-card-text-chile">{card.text}</div>
              </div>
            ))}
          </div>
        </section>
        <section id="cobertura" className="cobertura-section-chile">
          <div className="cobertura-title-chile">Cobertura</div>
          <div className="map-container-chile">
            <Mapa2 />
          </div>
        </section>
        {!ismobile && (
          <section className="torres-section-chile">
            <div className="torres-title-chile">Nuestras Torres Ejecutivas</div>
            <div className="torres-subtitle-chile">
              Presencia exclusiva en los principales edificios de Santiago, con pantallas estratégicamente ubicadas
              dentro de ascensores, lobbys de acceso y halls de circulación.
            </div>
            <div className="torres-carousel-container-chile">
              {edificios.length === 0 ? (
                <div>No hay edificios disponibles.</div>
              ) : (
                <>
                  <div className="torres-carousel-chile">
                    <div
                      className="torres-carousel-inner-chile"
                      style={{ transform: `translateX(-${currentIndex * 100}%)` }}
                    >
                      {edificios.map((edificio, index) => (
                        <div key={edificio.id} className="torres-card-chile">
                          <div className="torres-visual-card-chile">
                            {imageSrc[edificio.id] ? (
                              <img src={imageSrc[edificio.id]} alt={edificio.edificio} loading="lazy" />
                            ) : (
                              <div className="image-placeholder-chile">Imagen no disponible</div>
                            )}
                            {/* <div className="torres-visual-info-chile">
                              <div className="torres-info-title-chile">
                                {edificio.edificio || "Edificio sin nombre"}
                              </div>
                              <div className="torres-info-subtitle-chile">
                                {edificio.ubicacion || "Ubicación no disponible"}
                              </div>
                            </div> */}
                          </div>
                          <div className="torres-info-card-chile">
                            <div className="torres-info-title-chile">{edificio.edificio || "Edificio sin nombre"}</div>
                            <div className="torres-info-subtitle-chile">
                              {edificio.ubicacion || "Ubicación no disponible"}
                            </div>
                            <div className="torres-info-subtitle-direccion-chile">
                              {edificio.direccion || "Direccion no disponible"}
                            </div>
                            <div className="torres-stats-chile">
                              <div className="stat-item-chile">
                                <div className="stat-number-chile">
                                  {edificio.personas.toLocaleString(getLocale(resolvedPais))}
                                </div>
                                <div className="stat-label-chile">Personas únicas diarias</div>
                              </div>
                              {edificio.pantallas > 0 && (
                                <div className="stat-item-chile">
                                  <div className="stat-number-chile">{edificio.pantallas}</div>
                                  <div className="stat-label-chile">Pantallas en ascensores</div>
                                </div>
                              )}
                              {edificio.espera > 0 && (
                                <div className="stat-item-chile">
                                  <div className="stat-number-chile">{edificio.espera}</div>
                                  <div className="stat-label-chile">Pantalla en el hall de espera</div>
                                </div>
                              )}
                              {edificio.totems > 0 && (
                                <div className="stat-item-chile">
                                  <div className="stat-number-chile">{edificio.totems}</div>
                                  <div className="stat-label-chile">Pantallas Circulación</div>
                                </div>
                              )}
                              <div className="stat-item-chile">
                                <div className="stat-number-chile">
                                  {edificio.empresaslistado ? edificio.empresaslistado.split(",").length : 0}
                                </div>
                                <div className="stat-label-chile">Empresas instaladas</div>
                              </div>
                            </div>
                            <hr className="separator-chile" />
                            <div className="carousel-arrows-container-chile">
                              <button
                                className="carousel-arrow-chile left-arrow-chile"
                                onClick={handlePrev}
                                disabled={edificios.length <= 1}
                              >
                                <FaChevronLeft />
                              </button>
                              <button
                                className="carousel-arrow-chile right-arrow-chile"
                                onClick={handleNext}
                                disabled={edificios.length <= 1}
                              >
                                <FaChevronRight />
                              </button>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </>
              )}
            </div>
          </section>
        )}
        <section className="presencia-section-chile">
          <h2>Presencia Regional</h2>
          <p>+15 años conectando con audiencias en edificios corporativos en Uruguay y Perú</p>
        </section>
        <section id="clientes" className="clientes-section-chile">
          <h2>Referencias Comerciales</h2>
          <p>Algunos clientes de los últimos 12 meses</p>
          <div className="clientes-logos-chile">
            <div className="carousel-track">
              {[...logos, ...logos].map((client, index) => (
                <img
                  key={index}
                  src={client.src}
                  alt={client.alt || `Logo ${index + 1}`} // Fallback si alt no está definido
                  onError={() => console.error(`Failed to load logo: ${client.alt || `Logo ${index + 1}`}`)}
                />
              ))}
            </div>
          </div>
        </section>
        {/* {!ismobile && (
          <section className="transformacion-chile" id="transformacion">
            <div className="transformacion-text-titulo-chile">Transformación Digital</div>
            <div className="transformacion-text-subtitulo-chile">
              Innovación que complementa su estrategia publicitaria con soluciones digitales a medida
            </div>
            <div className="transformacion-content-chile">
              <div className="transformacion-video-chile">
                <iframe
                  width="560"
                  height="315"
                  src="https://www.youtube.com/embed/1aiLq_-DMUM?si=0MNT9QssceurkTi3"
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                />
              </div>
              <div className="transformacion-text-chile">
                <div className="transformacion-text-subtitulo-seccion-chile">
                  Además de nuestra oferta publicitaria, somos expertos en transformación digital, brindando soluciones
                  que potencian la comunicación de su empresa puertas adentro y hacia sus clientes.
                </div>
                <div className="transformacion-text-subtitulo-verde-chile">Pantallas LED de última generación</div>
                <div className="transformacion-text-bajada-chile">
                  Instalación de pantallas interiores, exteriores, formatos curvos, transparentes o 3D
                </div>
                <div className="transformacion-text-subtitulo-verde-chile">Desarrollo de contenidos</div>
                <div className="transformacion-text-bajada-chile">
                  Contenidos a medida, interactivos y dinámicos para comunicación efectiva
                </div>
                <div className="transformacion-text-subtitulo-verde-chile">Cartelería digital</div>
                <div className="transformacion-text-bajada-chile">
                  Soluciones completas para puntos de venta, oficinas y espacios corporativos
                </div>
              </div>
            </div>
          </section>
        )}
        {!ismobile && (
          <section>
            <div className="soluciones-chile">
              <div className="soluciones-text-titulo-chile">Soluciones Integrales</div>
              <div className="soluciones-text-subtitulo-seccion-chile">
                Contenidos a medida, interactivos y dinámicos para comunicación efectiva
              </div>
              <div className="soluciones-tarjetas-chile">
                {[
                  {
                    icon: consultoriaIcon,
                    title: "Consultoría",
                    text: "Evaluamos sus necesidades y diseñamos la estrategia digital más adecuada para su empresa",
                  },
                  {
                    icon: implementacionIcon,
                    title: "Implementación",
                    text: "Instalación de hardware, desarrollo de software y contion de sistemas",
                  },
                  {
                    icon: mantenimientoIcon,
                    title: "Mantenimiento",
                    text: "Soporte continuo, actualizaciones de contenido y mantenimiento preventivo",
                  },
                ].map((card, index) => (
                  <div key={index} className="soluciones-card-chile">
                    <img src={card.icon} alt={card.title} className="icon-chile" />
                    <h3>{card.title}</h3>
                    <p>{card.text}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>
        )} */}
        <section id="contacto" className="contacto-section-chile">
          <div className="contacto-info-chile">
            <div className="footer-contact-section-chile">
              <h2>hola@wecast.cl</h2>
              <h2>+56 9 3398 8184</h2>
              {/* <div className="contacto-socials-chile">
                <a href="https://instagram.com">
                  <img src={logoInstagram} alt="Instagram" className="social-icon-chile" />
                </a>
                <a href="https://linkedin.com">
                  <img src={logoLinkedin} alt="LinkedIn" className="social-icon-chile" />
                </a>
                <a href="https://youtube.com">
                  <img src={logoYoutube} alt="YouTube" className="social-icon-chile" />
                </a>
              </div> */}
              <div className="contacto-regions-chile">
                <img src={banderaUruguay} alt="Uruguay" className="flag-icon-chile" />
                <img src={banderaPeru} alt="Peru" className="flag-icon-chile" />
              </div>
            </div>
          </div>
          <div className="contacto-form-container-chile">
            <h2>Envíanos un mensaje</h2>
            <form className="contacto-form-chile" onSubmit={handleSubmit}>
              <input
                type="text"
                name="nombre"
                placeholder="Nombre*"
                value={formData.nombre}
                onChange={handleInputChange}
                required
              />
              <input
                type="email"
                name="email"
                placeholder="Email*"
                value={formData.email}
                onChange={handleInputChange}
                required
              />
              <input
                type="tel"
                name="telefono"
                placeholder="Teléfono"
                value={formData.telefono}
                onChange={handleInputChange}
              />
              <textarea
                name="mensaje"
                placeholder="Mensaje*"
                value={formData.mensaje}
                onChange={handleInputChange}
                required
              />
              <button type="submit" className="btn-primary-chile" disabled={submitStatus === "loading"}>
                {submitStatus === "loading" ? "Enviando..." : "Enviar"}
              </button>
            </form>
            {submitStatus === "success" && <p className="success-message-chile">¡Mensaje enviado con éxito!</p>}
            {submitStatus === "error" && <p className="error-message-chile">Error al enviar el mensaje.</p>}
          </div>
        </section>
      </main>

      {/* {!ismobile && (
        <footer className="footer-chile">
          <div className="footer-container-chile">
            <div className="footer-grid-chile">
              <div className="footer-left-chile">
                <div className="footer-logo-section-chile">
                  <span className="navbar-logo-text-chile" aria-label="Wecast">
                    wecast
                  </span>{" "}
                </div>
              </div>
              <div className="footer-right-chile">
                <div className="footer-section-chile">
                  <ul className="footer-links-chile">
                    <li>
                      <a href="#servicios">Servicios</a>
                    </li>
                    <li>
                      <a href="#cobertura">Cobertura</a>
                    </li>
                    <li>
                      <a href="#clientes">Clientes</a>
                    </li>
                    <li>
                      <a href="#transformacion">Transformación digital</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </footer>
      )} */}
    </>
  );
};

export default LandingChile;
